import React from 'react';
import jsPDF from 'jspdf';
import ImageManager from '../classes/image_manager.js';
import ProductStore from '../store/product-store.js';
import InternationalizationStore from '../store/internationalization-store.js';
import WordFind from '../wordfind.js';

const route = "img/vocabs/";

class GeneratePDF {

    constructor() {
        this.imageManager = new ImageManager()
        this.imagePaths = [];
        this.images = [];
    }

    generateFlashcardPDF(vocabs, language) {
        return new Promise(function (resolve) {
            this.imagePaths = [];

            var ietf = language.ietf;
            this.loadFlag(ietf);

            var logo = ProductStore.getLogo();
            this.imagePaths.push(logo);

            var backgroundPath = "img/printables/FlashCard.png";
            this.imagePaths.push(backgroundPath);

            this.loadVocabImagePaths(vocabs);

            this.pdf = this.getJSPDF();
            this.pdf.setTextColor(33, 20, 60);
            this.width = this.pdf.internal.pageSize.getWidth();
            this.height = this.pdf.internal.pageSize.getHeight();

            this.loadImages().then(function () {
                var background = this.images[backgroundPath];
                var flag = this.getFlag(ietf);
                logo = this.images[logo];

                for (var i = 0; i < vocabs.length && i < 10; i++) {
                    if (i != 0) {
                        this.pdf.addPage();
                    }
                    this.pdf.addImage(background.imageUrl, 'JPEG', 0, 0, this.width, this.height);

                    if (flag != undefined) {
                        this.pdf.addImage(flag.imageUrl, 'JPEG', this.width - 60, 25, 28 * 1.3, 17 * 1.3);
                    }

                    this.pdf.addImage(logo.imageUrl, 'JPEG', this.width / 2 - 23, this.height - 25, 28 * 1.8, 12 * 1.2);

                    this.createFlashcard(vocabs[i]);
                }

                this.pdf.save(InternationalizationStore.get(324, "Flashcard") + " .pdf");
                resolve();
            }.bind(this));
        }.bind(this));
    }

    createFlashcard(vocab) {
        var image = this.images[route + vocab.picture];
        this.pdf.addImage(image.imageUrl, 'JPEG', this.width / 2 - 60, this.height / 2 - 50, 120, 100);

        var text1 = vocab.word;
        var x1 = this.width / 2;
        this.pdf.setFontSize(50);
        var text1Width = this.pdf.getStringUnitWidth(text1) * this.pdf.internal.getFontSize() / this.pdf.internal.scaleFactor;

        var text1Offset = x1 - text1Width / 2;
        this.pdf.addImage(this.textToImage(vocab.word), 'JPEG', x1 - 50, this.height / 2 + 80 - 10, 100, 66);
        //this.pdfText(text1Offset, this.height/2 + 80, vocab.word);
    }

    generateVocabPDF(vocabs, language) {
        return new Promise(function (resolve) {
            this.imagePaths = [];
            var ietf = language.ietf;
            this.loadFlag(ietf);

            var logo = ProductStore.getLogo();
            this.imagePaths.push(logo);
            var backgroundPath = "img/printables/VocabList.png";
            this.imagePaths.push(backgroundPath);

            //this.loadVocabImagePaths(vocabs);

            this.pdf = this.getJSPDF();
            this.pdf.setTextColor(33, 20, 60);
            this.width = this.pdf.internal.pageSize.getWidth();
            this.height = this.pdf.internal.pageSize.getHeight();

            this.loadImages().then(function () {
                var background = this.images[backgroundPath];
                this.pdf.addImage(background.imageUrl, 'JPEG', 0, 0, this.width, this.height);
                var flag = this.getFlag(ietf);
                logo = this.images[logo];
                for (var i = 0; i < vocabs.length && i < 10; i++) {
                    this.createSingleVocabEntry(vocabs[i], i, false);
                }

                if (flag != undefined) {
                    this.pdf.addImage(flag.imageUrl, 'JPEG', this.width - 81, 28, 28 * 0.8, 17 * 0.75);
                }

                this.pdf.addImage(logo.imageUrl, 'JPEG', this.width / 2 - 22, this.height - 56, 28 * 1.4, 12 * 1);


                this.pdf.addPage();
                this.pdf.addImage(background.imageUrl, 'JPEG', 0, 0, this.width, this.height);

                if (flag != undefined) {
                    this.pdf.addImage(flag.imageUrl, 'JPEG', this.width - 81, 28, 28 * 0.8, 17 * 0.75);
                }

                this.pdf.addImage(logo.imageUrl, 'JPEG', this.width / 2 - 22, this.height - 56, 28 * 1.4, 12 * 1);


                for (var i = 0; i < vocabs.length && i < 10; i++) {
                    this.createSingleVocabEntry(vocabs[i], i, true);
                }

                this.pdf.save(InternationalizationStore.get(329, "Vocab List") + " .pdf");
                resolve();
            }.bind(this));
        }.bind(this));
    }

    setTextSize(text) {
        this.pdf.setFontSize(14);
        var size = this.pdf.getStringUnitWidth(text) * this.pdf.internal.getFontSize() / this.pdf.internal.scaleFactor;
        if (size > 40) {
            this.pdf.setFontSize(10);
        } else if (size > 50) {
            this.pdf.setFontSize(6);
        }
    }

    createSingleVocabEntry(vocab, position, isSecondList) {
        var yOffset = 70;

        var x1 = 68;
        var x2 = 142;
        var text1 = vocab.word;
        var text2 = vocab.originalWord;
        var y = yOffset + (position * 17.89);
        this.setTextSize(vocab.originalWord);
        // this.pdf.addImage(this.textToImage(text1), 'JPEG', x1 - 35, y - 10, 75, 48);
        var splitTitle = this.pdf.splitTextToSize(text1, 130);
        this.pdfText(x1 - 35,  y - 20, this.getFormattedText(splitTitle[0]), 75, 48);
        //this.pdfText(text1Offset, y, text1);
        if (!isSecondList) {
            this.setTextSize(vocab.originalWord);
            //this.pdf.addImage(this.textToImage(text2), 'JPEG', x2 - 25, y - 10, 75, 48);
            var splitTitle = this.pdf.splitTextToSize(text2, 130);
            this.pdfText(x2 - 40,  y - 20, this.getFormattedText(splitTitle[0]), 75, 48);
            //this.pdfText(text2Offset, y, text2);
        }
    }

    getJSPDF(type) {
        var pdf = new jsPDF(type);
        return pdf;
    }

    pdfText(x,y,text, width, height) {
        this.pdf.addImage(this.textToImage(text), 'JPEG', x, y, width, height);
    }

    getFormattedText(text) {
        text = text.replace("ā", "a"); 
        text = text.replace("ō", "o"); 
        return text;
    }

    textToImage(text) {
        function wrapText(context, text, x, y, maxWidth, lineHeight) {
            var words = text.split(' ');
            var line = '';

            for (var n = 0; n < words.length; n++) {
                var testLine = line + words[n] + ' ';
                var metrics = context.measureText(testLine);
                var testWidth = metrics.width;
                if (testWidth > maxWidth && n > 0) {
                    context.fillText(line, x, y);
                    line = words[n] + ' ';
                    y += lineHeight;
                }
                else {
                    line = testLine;
                }
            }
            context.fillText(line, x, y);
        }

        var ctx = document.getElementById("canvasPdf");
        if (ctx == null || ctx == undefined) {
            var canvas = document.createElement('canvas');
            canvas.id = "canvasPdf";
            canvas.width = 600;
            canvas.height = 400;
            canvas.style.zIndex = 8;
            canvas.style.position = "absolute";
            canvas.style.border = "0px solid";

            var body = document.getElementsByTagName("body")[0];
            body.appendChild(canvas);
        }
        var canvas = document.getElementById('canvasPdf');
        ctx = canvas.getContext('2d');
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.font = "60px arial";
        ctx.textAlign = "center";
        wrapText(ctx, text, 300, 50, 500, 60);
        return canvas.toDataURL();
    }


    setTextSize(text) {
        this.pdf.setFontSize(14);
        var size = this.pdf.getStringUnitWidth(text) * this.pdf.internal.getFontSize() / this.pdf.internal.scaleFactor;
        if (size > 40) {
            this.pdf.setFontSize(10);
        } else if (size > 50) {
            this.pdf.setFontSize(6);
        }
    }


    loadImages() {
        return new Promise(function (resolve) {
            this.imageManager.getDataUrls(this.imagePaths).then(function (images) {
                this.images = images;
                resolve();
            }.bind(this));
        }.bind(this));
    };

    loadVocabImagePaths(vocabs) {
        for (var i = 0; i < vocabs.length; i++) {
            var path = "img/vocabs/" + vocabs[i].picture;
            this.imagePaths.push(path);
        }
    }

    generateClassPDF(className, students) {

        if (typeof students === 'object') {
            var temp = [];
            for (var property in students) {
                if (students.hasOwnProperty(property)) {
                    temp.push(students[property])
                }
            }
            students = temp;
        }

        students = this.orderStudentsAlphabet(students);

        this.pdf = this.getJSPDF();
        this.pdf.setTextColor(33, 20, 60);
        var logo = ProductStore.getLogo();

        this.imageManager.getDataUrl([logo]).then(function (logoObj) {
            logo = logoObj;
            var idx = 0;
            for (var i = 0; i < students.length; i++) {
                if (i % 10 == 0 && i != 0) {
                    this.pdf.addPage();
                    idx = 0;
                }
                students[i].currentClass = className;
                students[i].logo = logo;
                this.createStudentLabel(students[i], idx, logo);
                idx++;
            }
            this.pdf.save(className + '.pdf');
        }.bind(this));
    }

    
    generateNoClassPDF(students) {

        if (typeof students === 'object') {
            var temp = [];
            for (var property in students) {
                if (students.hasOwnProperty(property)) {
                    temp.push(students[property])
                }
            }
            students = temp;
        }

        students = this.orderStudentsAlphabet(students);

        this.pdf = this.getJSPDF();
        this.pdf.setTextColor(33, 20, 60);
        var logo = ProductStore.getLogo();

        this.imageManager.getDataUrl([logo]).then(function (logoObj) {
            logo = logoObj;
            var idx = 0;
            for (var i = 0; i < students.length; i++) {
                if (i % 10 == 0 && i != 0) {
                    this.pdf.addPage();
                    idx = 0;
                }
                students[i].logo = logo;
                this.createStudentLabel(students[i], idx, logo);
                idx++;
            }
            this.pdf.save('students.pdf');
        }.bind(this));
    }

    generateOxfordLicencesPDF(students, userName, limit) {

        if (typeof students === 'object') {
            var temp = [];
            for (var property in students) {
                if (students.hasOwnProperty(property)) {
                    temp.push(students[property])
                }
            }
            students = temp;
        }

        this.pdf = this.getJSPDF();
        this.pdf.setTextColor(33, 20, 60);
        var logo = ProductStore.getLogo();

        this.imageManager.getDataUrl([logo]).then(function (logoObj) {
            logo = logoObj;
            var idx = 0;
            for (var i = 0; i < students.length && i < limit; i++) {
                if (i % 10 == 0 && i != 0) {
                    this.pdf.addPage();
                    idx = 0;
                }
                students[i].logo = logo;
                this.createLicenceLabel(students[i], idx, userName);
                idx++;
            }
            this.pdf.save('licences.pdf');
        }.bind(this));
    }


    orderStudentsAlphabet(students) {
        students.sort(function (a, b) {
            var nameA = a.name.toLowerCase(), nameB = b.name.toLowerCase();
            if (nameA < nameB) //sort string ascending
                return -1;
            if (nameA > nameB)
                return 1;
            return 0; //default return value (no sorting)
        });
        return students;
    }

    createLicenceLabel(data, position, userNameOverall) {

        var createSingleLabel = function (x, y, w, h, xScale, yScale, data) {
            var classText = InternationalizationStore.get("320", "Class");
            var username = InternationalizationStore.get("22", "Username");
            var password = InternationalizationStore.get("23", "Password");
            
            var currentClass = classText + ": " + data.currentClass;
            username = username + ": " + userNameOverall;
            var pass = "Login ID: " + data.uid;
            this.pdf.rect(x * xScale, y * yScale, w * xScale, h * yScale);
            var logo = data.logo;
            var ratio = logo.h / logo.w;
            var width = 20;
            var height = width * ratio;
            width = width * xScale;
            height = height * yScale;
            this.pdf.setFontSize(12);
            this.pdf.addImage(logo.imageUrl, 'JPEG', (x + 15) * xScale, (y + 2) * yScale, width, height - 2);
            if (data.currentClass == undefined) {
                this.pdf.text((x + 5) * xScale, (y + 9) * yScale, this.getFormattedText(username));
                this.pdf.text((x + 5) * xScale, (y + 12) * yScale, this.getFormattedText(pass));
                //this.pdf.setFontStyle("bold");
                this.pdf.text((x + 15) * xScale, (y + 18) * yScale, "English Proficiency Test");
                //this.pdf.setFontStyle('normal');
            } else {
                this.pdf.text((x + 5) * xScale, (y + 12) * yScale, this.getFormattedText(currentClass));
                this.pdf.text((x + 5) * xScale, (y + 15) * yScale, this.getFormattedText(username));
                this.pdf.text((x + 5) * xScale, (y + 18) * yScale, this.getFormattedText(pass));
            }

        }.bind(this);

        var idx = position + 1;
        var PDFwidth = this.pdf.internal.pageSize.getWidth() || 210.00197555866663;

        console.log(PDFwidth);
        var PDFheight = this.pdf.internal.pageSize.getHeight() || 297.0006773335;
        console.log(PDFheight);
        var xScale = PDFwidth / 100;
        var yScale = PDFheight / 100;
        var labelWidth = 100 / 2;
        var labelHeight = 100 / 5;

        var x, y
        idx % 2 == 1 ? x = 0 : x = 1;
        y = Math.ceil(idx / 2) - 1;
        x = x * labelWidth;
        y = y * labelHeight;

        this.pdf.setDrawColor(33, 20, 60);
        this.pdf.setFillColor(0, 0, 0);

        createSingleLabel(x, y, labelWidth, labelHeight, xScale, yScale, data);
    }

    createStudentLabel(data, position) {

        var createSingleLabel = function (x, y, w, h, xScale, yScale, data) {
            var name = InternationalizationStore.get("14", "Name");
            var classText = InternationalizationStore.get("320", "Class");
            var username = InternationalizationStore.get("22", "Username");
            var password = InternationalizationStore.get("23", "Password");
            name = name + ": " + data.name;
            
            var currentClass = classText + ": " + data.currentClass;
            username = username + ": " + data.username;
            var pass = password + ": " + data.password;
            this.pdf.rect(x * xScale, y * yScale, w * xScale, h * yScale);
            var logo = data.logo;
            var ratio = logo.h / logo.w;
            var width = 20;
            var height = width * ratio;
            width = width * xScale;
            height = height * yScale;
            this.pdf.setFontSize(12);
            this.pdf.addImage(logo.imageUrl, 'JPEG', (x + 15) * xScale, (y + 2) * yScale, width, height - 2);
            this.pdf.text((x + 5) * xScale, (y + 9) * yScale, this.getFormattedText(name));
            if (data.currentClass == undefined) {
                this.pdf.text((x + 5) * xScale, (y + 12) * yScale, this.getFormattedText(username));
                this.pdf.text((x + 5) * xScale, (y + 15) * yScale, this.getFormattedText(pass));
            } else {
                this.pdf.text((x + 5) * xScale, (y + 12) * yScale, this.getFormattedText(currentClass));
                this.pdf.text((x + 5) * xScale, (y + 15) * yScale, this.getFormattedText(username));
                this.pdf.text((x + 5) * xScale, (y + 18) * yScale, this.getFormattedText(pass));
            }

        }.bind(this);

        var idx = position + 1;
        var PDFwidth = this.pdf.internal.pageSize.getWidth() || 210.00197555866663;

        console.log(PDFwidth);
        var PDFheight = this.pdf.internal.pageSize.getHeight() || 297.0006773335;
        console.log(PDFheight);
        var xScale = PDFwidth / 100;
        var yScale = PDFheight / 100;
        var labelWidth = 100 / 2;
        var labelHeight = 100 / 5;

        var x, y
        idx % 2 == 1 ? x = 0 : x = 1;
        y = Math.ceil(idx / 2) - 1;
        x = x * labelWidth;
        y = y * labelHeight;

        this.pdf.setDrawColor(33, 20, 60);
        this.pdf.setFillColor(0, 0, 0);

        createSingleLabel(x, y, labelWidth, labelHeight, xScale, yScale, data);
    }

    generateSnapPDF(vocabs, language) {

        return new Promise(function (resolve) {
            this.imagePaths = [];

            var backgroundPath = "img/printables/Snap.png";
            this.imagePaths.push(backgroundPath);

            this.loadVocabImagePaths(vocabs);

            var xMargin = 1;
            var yMargin = 4;

            this.pdf = this.getJSPDF();
            this.pdf.setTextColor(33, 20, 60);
            this.pageWidth = this.pdf.internal.pageSize.getWidth();
            this.pageHeight = this.pdf.internal.pageSize.getHeight();
            this.width = this.pageWidth - (xMargin * 2);
            this.height = this.pageHeight - (yMargin * 2);
            this.x0 = xMargin;
            this.y0 = yMargin;

            var numWidth = 2;
            var numHeight = 5;

            var positions = this.getPositionMatrix(this.pageWidth, this.pageHeight, numWidth, numHeight);

            this.loadImages().then(function () {
                var background = this.images[backgroundPath];
                this.pdf.addImage(background.imageUrl, 'JPEG', 0, 0, this.pageWidth, this.pageHeight);

                var idx = 0;
                for (var i = 0; i < vocabs.length; i++) {
                    if (idx % 10 == 0 && idx != 0) {
                        this.pdf.addPage();
                        this.pdf.addImage(background.imageUrl, 'JPEG', 0, 0, this.pageWidth, this.pageHeight);
                        idx = 0;
                    }
                    this.createSingleSnapVocab(vocabs[i], positions, idx, false);
                    idx++;
                }

                for (var i = 0; i < vocabs.length; i++) {
                    if (idx % 10 == 0 && idx != 0) {
                        this.pdf.addPage();
                        this.pdf.addImage(background.imageUrl, 'JPEG', 0, 0, this.pageWidth, this.pageHeight);
                        idx = 0;
                    }
                    this.createSingleSnapVocab(vocabs[i], positions, idx, true);
                    idx++;
                }

                this.pdf.save(InternationalizationStore.get(328, "Snap") + " .pdf");
                resolve();
            }.bind(this));
        }.bind(this));
    }

    createSingleSnapVocab(vocab, positions, position, isImage) {
        var idx = position + 1;
        var x, y;

        idx % 2 == 1 ? x = 0 : x = 1;
        y = Math.ceil(idx / 2) - 1;
        var posObj = positions[x][y];
        var textX = this.x0 + posObj.x + (posObj.w / 2);
        var textY = this.y0 + posObj.y + (posObj.h / 2) - 3;

        var text = vocab.word;

        var text1Width = this.pdf.getStringUnitWidth(text) * this.pdf.internal.getFontSize() / this.pdf.internal.scaleFactor;
        var text1Offset = textX - text1Width / 2;


        if (isImage) {
            var image = this.images[route + vocab.picture];
            this.pdf.addImage(image.imageUrl, 'JPEG', textX - 23, textY - 20, 46, 40);
        } else {

            this.pdf.addImage(this.textToImage(text), 'JPEG', textX - 50, textY - 10, 100, 66);
            //this.pdfText(text1Offset, textY, vocab.word);
        }
    }

    getPositionMatrix(width, height, numWidth, numHeight) {
        var sectionWidth = width / numWidth;
        var sectionHeight = height / numHeight;

        var matrix = [];

        for (var x = 0; x < numWidth; x++) {
            matrix.push([]);
            for (var y = 0; y < numHeight; y++) {
                var position = {};
                position.x = x * sectionWidth;
                position.y = y * sectionHeight;
                position.w = sectionWidth;
                position.h = sectionHeight;
                matrix[x].push(position);
            }
        }
        return matrix;
    }

    loadFlag(country) {
        var path = "img/flags/" + country + ".png";
        this.imagePaths.push(path);
    }

    getFlag(country) {
        if (this.images["img/flags/" + country + ".png"] != undefined) {
            return this.images["img/flags/" + country + ".png"];
        } else {
            return undefined;
        }
    }

    generateDicePDF(vocabs, language) {
        return new Promise(function (resolve) {

            this.pdf = this.getJSPDF('landscape');
            this.pdf.setTextColor(33, 20, 60);

            this.imagePaths = [];
            var backgroundPath = "img/printables/DiceTemplate.png";
            this.imagePaths.push(backgroundPath);

            var ietf = language.ietf;
            this.loadFlag(ietf);

            var logo = ProductStore.getLogo();
            this.imagePaths.push(logo);

            this.test = "img/printables/1003.png";
            this.imagePaths.push(this.test);

            this.pageWidth = this.pdf.internal.pageSize.getWidth();
            this.pageHeight = this.pdf.internal.pageSize.getHeight();

            this.loadVocabImagePaths(vocabs);

            var numVocab = Math.min(6, vocabs.length);
            this.loadImages().then(function () {
                var background = this.images[backgroundPath];

                var flag = this.getFlag(ietf);
                logo = this.images[logo];

                this.pdf.addImage(background.imageUrl, 'JPEG', 0, 0, this.pageWidth, this.pageHeight);


                if (flag != undefined) {
                    this.pdf.addImage(flag.imageUrl, 'JPEG', this.pageWidth - 84, 10, 28 * 1.3, 17 * 1.3);
                }

                this.pdf.addImage(logo.imageUrl, 'JPEG', 30, this.pageHeight - 25, 32 * 1.6, 12 * 1.2);

                for (var i = 0; i < numVocab; i++) {
                    this.createDice(vocabs[i], i, false);
                }

                this.pdf.addPage();
                this.pdf.addImage(background.imageUrl, 'JPEG', 0, 0, this.pageWidth, this.pageHeight);


                if (flag != undefined) {
                    this.pdf.addImage(flag.imageUrl, 'JPEG', this.pageWidth - 84, 10, 28 * 1.3, 17 * 1.3);
                }

                this.pdf.addImage(logo.imageUrl, 'JPEG', 30, this.pageHeight - 25, 32 * 1.6, 12 * 1.2);

                for (var i = 0; i < numVocab; i++) {
                    this.createDice(vocabs[i], i, true);
                }
                this.pdf.save(InternationalizationStore.get(326, "Dice") + " .pdf");
                resolve();
            }.bind(this));

        }.bind(this));
    }

    createDice(vocab, pos, isImage) {
        var x1 = 35;
        var y1 = this.pageWidth / 2 - 40;
        var xGap = 57.5;
        var positions = [{ x: x1, y: y1 }, { x: x1 + xGap, y: y1 }, { x: x1 + xGap * 2, y: y1 }, { x: x1 + xGap * 3, y: y1 }, { x: x1 + xGap * 2, y: y1 - xGap }, { x: x1 + xGap * 2, y: y1 + xGap }]
        var position = positions[pos];
        if (vocab.word.constructor === Array) {
            vocab.word = vocab.word[0];
        }
        if (isImage) {

            var test = this.images[route + vocab.picture];
            this.pdf.addImage(test.imageUrl, 'JPEG', position.x - 4, position.y - 22, 46, 40);
        } else {
            if (this.pdf.internal.getFontSize() < 13) {
                var offset = 0;
            } else {
                var offset = 0;
            }
            if (vocab.word != undefined) {

                this.pdf.addImage(this.textToImage(vocab.word), 'JPEG', position.x - 7, position.y - 5, 50, 33);
            }
            //this.pdfText(position.x+16, position.y, vocab.word, undefined, undefined, "center");
        }
    }

    processVocabs(vocabs, level){
        var newVocabs = [];

        for (var i = 0; i < vocabs.length; i++){

            var vocab = vocabs[i];
            vocab.displayWord = vocab.word;
                vocab.word = vocab.word.replace(/\s/g, "");


            var len = vocab.word.length;
            var valid = true;
            if (level == 1){
                valid = len < 14;
            } else if (level ==2){
                valid = len < 18;
            } else {
                valid = len < 22;
            }
            if (valid){
                newVocabs.push(vocab);
            }
        }
        return newVocabs;
    }


    generateWordSearch(vocabs, language, level) {

        vocabs = this.processVocabs(vocabs, level);

        return new Promise(function (resolve) {
            this.pdf = this.getJSPDF('portrait');
            this.pdf.setTextColor(33, 20, 60);

            this.imagePaths = [];
            var backgroundPath = "img/printables/WordsearchSmall.jpg"
            if (level == 2) {
                backgroundPath = "img/printables/WordsearchMedium.jpg";
            } else if (level == 3) {
                backgroundPath = "img/printables/Wordsearch.jpg";
            }

            this.imagePaths.push(backgroundPath);

            var ietf = language.ietf;
            this.loadFlag(ietf);

            this.pageWidth = this.pdf.internal.pageSize.getWidth();
            this.pageHeight = this.pdf.internal.pageSize.getHeight();

            var numVocab = Math.min(10, vocabs.length);
            this.loadImages().then(function () {
                var background = this.images[backgroundPath];

                var flag = this.getFlag(ietf);
                var name = InternationalizationStore.get(14, "Name") + ":"

                this.pdf.addImage(background.imageUrl, 'JPEG', 0, 0, this.pageWidth, this.pageHeight);
                this.pdf.text( 19 , 30 * 0.75 , this.getFormattedText(name));

                var offset = 0;
                if (level == 2 || level == 3){
                    offset = 3;
                }

                if (flag != undefined) {
                    this.pdf.addImage(flag.imageUrl, 'JPEG', this.pageWidth - 67 + offset, 8, (20 * 1.3), 19 * 0.75);
                }

                var vocabCount = 0;
                for (var x = 0; x < 2; x++) {
                    for (var y = 0; y < 5; y++) {

                        if (vocabCount < numVocab) {
                            this.addVocabWordsearch(vocabs[vocabCount], x, y, level);
                        }
                        vocabCount = vocabCount + 1;
                    }
                }

                this.addWordsearchContent(vocabs, level);

                this.pdf.save(InternationalizationStore.get('ui-205', "Word Search") + " .pdf");

                resolve();
            }.bind(this));

        }.bind(this));

    }

    addWordsearchContent(vocabs, level) {

        var vocArray = [];

        var xoffset = 25;
        var yoffset = 38;
        var gap = 12;
        var size = 14;

        if (level == 3){
            xoffset = 15;
            yoffset = 32;
            gap = 8.5;
            size = 22;


        } else if (level == 2){
            xoffset = 17;
            yoffset = 33;
            gap = 10.2;
            size = 18;
        }
        for (var i = 0; i < vocabs.length; i++) {
            vocArray.push(vocabs[i].word);
        }

        var words = new WordFind();
        var puzzle = words.newPuzzle(vocArray, { height: size, width: size });
        var x = puzzle;
        this.pdf.setFontSize(15);

        for (var x = 0; x < puzzle.length; x++) {
            for (var y = 0; y < puzzle[x].length; y++) {
                var xp = xoffset + (x * gap);
                var yp = yoffset + (y * gap);
                var puzz = puzzle[x][y];
                this.pdf.text(xp, yp, this.getFormattedText(puzz));
            }
        }

    }

    addVocabWordsearch(vocab, x, y, level) {

        //console.log(vocab);
        var offsetX = 20;
        var offsetY = 220;
        if (level == 1){
            offsetY = 213;
        }
        var spacingX = this.pageWidth / 2 - 10;
        var spacingY = 13;

        var x = offsetX + (x * spacingX);
        var y = offsetY + (y * spacingY);

        this.pdf.setFontSize(16);
        this.pdf.text(x, y, this.getFormattedText(vocab.displayWord));

    }
}

export default GeneratePDF;